import { render, staticRenderFns } from "./UserGreeting.vue?vue&type=template&id=8dd4d0f4&scoped=true"
import script from "./UserGreeting.vue?vue&type=script&lang=js"
export * from "./UserGreeting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd4d0f4",
  null
  
)

export default component.exports